import { getAccountantData } from 'api/v3/access/accountantsAuth';
import i18n from 'i18n';
import isNil from 'lodash/isNil';
import { useQuery, UseQueryOptions } from 'react-query';
import { AccountCacheKeys } from 'types/cacheKeys.types';
import { AvailableLanguages } from 'types/users.types';
import { isExpert } from 'utils/constants';
import { getStoredExpertAuthData } from 'utils/expertAuth';

/**
 * Simple expert-specific version of useGetLoggedInUserData
 */
const useGetExpertLoggedInUserData = (options?: UseQueryOptions) => {
  const authData = getStoredExpertAuthData();
  const enabled = isExpert && !!authData?.auth?.access_token;

  return useQuery([AccountCacheKeys.AccountantData], getAccountantData, {
    enabled,
    onSuccess: (accountant) => {
      const userLanguage = accountant.language || AvailableLanguages.en;

      if (i18n.language === userLanguage) return;

      i18n.changeLanguage(userLanguage);
    },
    ...(options as any),
  });
};

export default useGetExpertLoggedInUserData;
